module.exports = __webpack_public_path__ + "img/9788968173776.90956ddc.jpg";